export enum UserType {
  Borrower = 'Borrower',
  Investor = 'Investor',
  Provider = 'Provider',
}

export interface User {
  id?: string;
  email: string;
  firstname: string;
  lastname: string;
  user_type_id: number;
}
